import { axiosInstance } from '../axiosConfig';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const rootInstance = axios.create({
    baseURL: API_BASE.endsWith('/') ? API_BASE : `${API_BASE}/`,
});

// ═══ TIPOS ═══
export interface LandingEspacio {
    id: number;
    label: string;
    alt: string;
    imagen: string | null;
    url_imagen: string | null;
    orden: number;
    activo: boolean;
    creado_en?: string;
    actualizado_en?: string;
}

export interface LandingExperiencia {
    id: number;
    tag: string;
    titulo: string;
    descripcion: string;
    stat: string;
    stat_label: string;
    color_acento: string;
    imagen: string | null;
    url_imagen: string | null;
    orden: number;
    activo: boolean;
    creado_en?: string;
    actualizado_en?: string;
}

export interface LandingSplitSectionItem {
    id: number;
    tag: string;
    titulo: string;
    descripcion: string;
    caracteristicas: string;
    caracteristicas_lista?: string[];
    imagen_izquierda: boolean;
    color_acento: string;
    texto_boton: string;
    enlace_boton: string;
    imagen: string | null;
    url_imagen: string | null;
    orden: number;
    activo: boolean;
    creado_en?: string;
    actualizado_en?: string;
}

// ═══════════════════════════════════════════
// 1. GALERÍA DE ESPACIOS (ACORDEÓN)
// ═══════════════════════════════════════════
export const fetchEspaciosPublic = async (): Promise<LandingEspacio[]> => {
    try {
        const res = await rootInstance.get('landing-espacios-public/');
        return res.data;
    } catch {
        const fallback = await axiosInstance.get('landing-espacios-public/');
        return fallback.data;
    }
};

export const fetchEspaciosAdmin = async (): Promise<LandingEspacio[]> => {
    const res = await axiosInstance.get('landing-espacios/');
    return res.data;
};

export const createEspacio = async (formData: FormData): Promise<LandingEspacio> => {
    const res = await axiosInstance.post('landing-espacios/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const updateEspacio = async (id: number, formData: FormData): Promise<LandingEspacio> => {
    const res = await axiosInstance.patch(`landing-espacios/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const deleteEspacio = async (id: number): Promise<void> => {
    await axiosInstance.delete(`landing-espacios/${id}/`);
};

export const reorderEspacios = async (items: { id: number; orden: number }[]): Promise<LandingEspacio[]> => {
    const res = await axiosInstance.post('landing-espacios/reordenar/', items);
    return res.data;
};

// ═══════════════════════════════════════════
// 2. CARRUSEL EXPERIENCIA / ASPIRACIÓN
// ═══════════════════════════════════════════
export const fetchExperienciaPublic = async (): Promise<LandingExperiencia[]> => {
    try {
        const res = await rootInstance.get('landing-experiencia-public/');
        return res.data;
    } catch {
        const fallback = await axiosInstance.get('landing-experiencia-public/');
        return fallback.data;
    }
};

export const fetchExperienciaAdmin = async (): Promise<LandingExperiencia[]> => {
    const res = await axiosInstance.get('landing-experiencia/');
    return res.data;
};

export const createExperiencia = async (formData: FormData): Promise<LandingExperiencia> => {
    const res = await axiosInstance.post('landing-experiencia/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const updateExperiencia = async (id: number, formData: FormData): Promise<LandingExperiencia> => {
    const res = await axiosInstance.patch(`landing-experiencia/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const deleteExperiencia = async (id: number): Promise<void> => {
    await axiosInstance.delete(`landing-experiencia/${id}/`);
};

export const reorderExperiencia = async (items: { id: number; orden: number }[]): Promise<LandingExperiencia[]> => {
    const res = await axiosInstance.post('landing-experiencia/reordenar/', items);
    return res.data;
};

// ═══════════════════════════════════════════
// 3. SECCIONES INFORMATIVAS DIVIDIDAS (SPLIT)
// ═══════════════════════════════════════════
export const fetchSplitSectionsPublic = async (): Promise<LandingSplitSectionItem[]> => {
    try {
        const res = await rootInstance.get('landing-secciones-public/');
        return res.data;
    } catch {
        const fallback = await axiosInstance.get('landing-secciones-public/');
        return fallback.data;
    }
};

export const fetchSplitSectionsAdmin = async (): Promise<LandingSplitSectionItem[]> => {
    const res = await axiosInstance.get('landing-secciones/');
    return res.data;
};

export const createSplitSection = async (formData: FormData): Promise<LandingSplitSectionItem> => {
    const res = await axiosInstance.post('landing-secciones/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const updateSplitSection = async (id: number, formData: FormData): Promise<LandingSplitSectionItem> => {
    const res = await axiosInstance.patch(`landing-secciones/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const deleteSplitSection = async (id: number): Promise<void> => {
    await axiosInstance.delete(`landing-secciones/${id}/`);
};

export const reorderSplitSections = async (items: { id: number; orden: number }[]): Promise<LandingSplitSectionItem[]> => {
    const res = await axiosInstance.post('landing-secciones/reordenar/', items);
    return res.data;
};
